import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDateParserFormatter, NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { Endorsement } from '../_models/endorsement';
import { ENDORSEMENT_MSGS } from 'src/app/_common/product-config';
import { EndorsementService } from '../_services/endorsement.service';
import { LOBType, DocumentFileType } from 'src/app/_common/_enum/module.enum';

@Component({
  selector: 'app-endorsement-basic-info',
  templateUrl: './endorsement-basic-info.component.html',
  styleUrls: ['./endorsement-basic-info.component.scss']
})

export class EndorsementBasicInfoComponent  implements OnInit { //extends RequestEndorsementComponent
  
  private policyEffectiveDate = {};
  private policyExpirationDate = {};
  private policyCancelDate = null;

  private lobTypeEnum = LOBType; // Using it in HTML
  private documentFileTypeEnum = DocumentFileType; // Using it in HTML

  private endorsementBasicInfo: Endorsement;
  private isSubmitted: boolean = false;
  private endorsementMsgs = ENDORSEMENT_MSGS;
  private effectiveDate = {};


  @ViewChild("basicInfoForm", {static: false}) basicInfo: NgForm;
  
  constructor(private route: ActivatedRoute, private calendar: NgbCalendar, private formatter: NgbDateParserFormatter, private changeDetector: ChangeDetectorRef, private endorsementService:EndorsementService, private el: ElementRef) { 
    //super(_route,_calendar,_formatter, _policyService);
  }

  ngOnInit() {
    this.endorsementBasicInfo = this.getEndorsement();
    let _policyEffectiveDate = new Date(this.endorsementBasicInfo.policyEffectiveDate);
    let _policyExpirationDate = new Date(this.endorsementBasicInfo.policyExpirationDate);
    _policyExpirationDate.setDate(_policyExpirationDate.getDate()-1);
    
    this.policyEffectiveDate = {year: _policyEffectiveDate.getFullYear(), month: _policyEffectiveDate.getMonth()+1, day: _policyEffectiveDate.getDate()};
    this.policyExpirationDate = {year: _policyExpirationDate.getFullYear(), month: _policyExpirationDate.getMonth()+1, day: _policyExpirationDate.getDate()};

    if(this.endorsementBasicInfo.policyCancelDate){
      let _policyCancelDate = new Date(this.endorsementBasicInfo.policyCancelDate);
      _policyCancelDate.setDate(_policyCancelDate.getDate()-1);
      this.policyCancelDate = {year: _policyCancelDate.getFullYear(), month: _policyCancelDate.getMonth()+1, day: _policyCancelDate.getDate()};
    }
  }

  ngAfterViewInit(){
    if(this.endorsementBasicInfo.effectiveDate!=null && this.basicInfo){
      this.basicInfo["effectiveDate"]=this.endorsementBasicInfo.effectiveDate;
      this.changeDetector.detectChanges();
    }
  }
  
  onEffectiveDateSelect(_event){
    if(_event!=null){
      this.endorsementBasicInfo.effectiveDate = this.formatter.format(_event); //new Date(this.formatter.format(_event));//new Date(_event.year, _event.month-1, _event.day);
    }else{
      this.endorsementBasicInfo.effectiveDate = this.formatter.format(this.formatter.parse(this.basicInfo["effectiveDate"]));
    }
  }

  getEndorsement(){
    return this.endorsementService.endorsement;
  }

  selectEndorsementType(_event, _endorsementType){
    if(_event){
      //this.endorsementBasicInfo.EndorsementForm.push(_endorsementType);
      if(Object.keys(this.endorsementBasicInfo.EndorsementForm).length===0){
        this.endorsementBasicInfo.EndorsementForm = {};
      }
      if(!this.endorsementBasicInfo.EndorsementForm[_endorsementType.type] || Object.keys(this.endorsementBasicInfo.EndorsementForm[_endorsementType.type]).length === 0){
          this.endorsementBasicInfo.EndorsementForm[_endorsementType.type] = {};
      }
      this.endorsementBasicInfo.EndorsementForm[_endorsementType.type][_endorsementType.endorsementType] = JSON.parse(JSON.stringify(_endorsementType));//Object.assign({}, _endorsementType);
    }else{
      delete this.endorsementBasicInfo.EndorsementForm[_endorsementType.type][_endorsementType.endorsementType];// = this.endorsementBasicInfo.EndorsementForm.filter((_selectedEndType:any)=>{ return _selectedEndType.uid!=_endorsementType.uid});
      if(Object.keys(this.endorsementBasicInfo.EndorsementForm[_endorsementType.type]).length == 0){
        delete this.endorsementBasicInfo.EndorsementForm[_endorsementType.type];
      }
    }
  }

  isPackageEndorsementTypeSelected(_lobType):boolean{
    return this.isEndorsementTypeSelected && this.endorsementBasicInfo.EndorsementForm[_lobType] && Object.keys(this.endorsementBasicInfo.EndorsementForm[_lobType]).length > 0;//this.endorsementBasicInfo.EndorsementForm.filter(_endorsement=> {return _endorsement.type.toLowerCase() == _lobType.toLowerCase()}).length>0;
  }
  
  get isEndorsementTypeSelected(): boolean{
    return Object.keys(this.endorsementBasicInfo.EndorsementForm).length > 0;//this.endorsementBasicInfo.EndorsementForm.length > 0;
  }

  acordFormSelected(_isAcord=false){
    if(_isAcord){
      let allDocuments = this.endorsementService.getSupportingDocuments();
      let newAllDocuments = [];
      allDocuments.forEach(document=>{
        if(document.docFileType == this.documentFileTypeEnum.Acord){
          newAllDocuments.push(document);
        }
      });

      this.endorsementService.setSupportingDocuments(newAllDocuments);
    }
  }

  onContinue():boolean{
    this.endorsementBasicInfo.hasAccountLevelEndorsement = this.endorsementBasicInfo.EndorsementForm["ACCOUNT"] && Object.keys(this.endorsementBasicInfo.EndorsementForm["ACCOUNT"]).length > 0;//.some(_form=>{return _form.type=="ACCOUNT" && _form.isSelected});
    
    this.isSubmitted = true;
    
    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
    }

    return (this.basicInfo.valid && this.isEndorsementTypeSelected && this.endorsementBasicInfo.isAcordForm != null && this.endorsementBasicInfo.isQuote != null);
  }
}
